// Global region centroids (approximate geographic centers)
// US States, Canadian Provinces, Mexican States, and European Regions
// Used for state-level aggregate markers before zoom
export const STATE_CENTROIDS = {
  // === US States ===
  AL: { lat: 32.806671, lng: -86.791130, name: 'Alabama' },
  AK: { lat: 61.370716, lng: -152.404419, name: 'Alaska' },
  AZ: { lat: 33.729759, lng: -111.431221, name: 'Arizona' },
  AR: { lat: 34.969704, lng: -92.373123, name: 'Arkansas' },
  CA: { lat: 36.116203, lng: -119.681564, name: 'California' },
  CO: { lat: 39.059811, lng: -105.311104, name: 'Colorado' },
  CT: { lat: 41.597782, lng: -72.755371, name: 'Connecticut' },
  DE: { lat: 39.318523, lng: -75.507141, name: 'Delaware' },
  DC: { lat: 38.897438, lng: -77.026817, name: 'District of Columbia' },
  FL: { lat: 27.766279, lng: -81.686783, name: 'Florida' },
  GA: { lat: 33.040619, lng: -83.643074, name: 'Georgia' },
  HI: { lat: 21.094318, lng: -157.498337, name: 'Hawaii' },
  ID: { lat: 44.240459, lng: -114.478828, name: 'Idaho' },
  IL: { lat: 40.349457, lng: -88.986137, name: 'Illinois' },
  IN: { lat: 39.849426, lng: -86.258278, name: 'Indiana' },
  IA: { lat: 42.011539, lng: -93.210526, name: 'Iowa' },
  KS: { lat: 38.526600, lng: -96.726486, name: 'Kansas' },
  KY: { lat: 37.668140, lng: -84.670067, name: 'Kentucky' },
  LA: { lat: 31.169546, lng: -91.867805, name: 'Louisiana' },
  ME: { lat: 44.693947, lng: -69.381927, name: 'Maine' },
  MD: { lat: 39.063946, lng: -76.802101, name: 'Maryland' },
  MA: { lat: 42.230171, lng: -71.530106, name: 'Massachusetts' },
  MI: { lat: 43.326618, lng: -84.536095, name: 'Michigan' },
  MN: { lat: 45.694454, lng: -93.900192, name: 'Minnesota' },
  MS: { lat: 32.741646, lng: -89.678696, name: 'Mississippi' },
  MO: { lat: 38.456085, lng: -92.288368, name: 'Missouri' },
  MT: { lat: 46.921925, lng: -110.454353, name: 'Montana' },
  NE: { lat: 41.125370, lng: -98.268082, name: 'Nebraska' },
  NV: { lat: 38.313515, lng: -117.055374, name: 'Nevada' },
  NH: { lat: 43.452492, lng: -71.563896, name: 'New Hampshire' },
  NJ: { lat: 40.298904, lng: -74.521011, name: 'New Jersey' },
  NM: { lat: 34.840515, lng: -106.248482, name: 'New Mexico' },
  NY: { lat: 42.165726, lng: -74.948051, name: 'New York' },
  NC: { lat: 35.630066, lng: -79.806419, name: 'North Carolina' },
  ND: { lat: 47.528912, lng: -99.784012, name: 'North Dakota' },
  OH: { lat: 40.388783, lng: -82.764915, name: 'Ohio' },
  OK: { lat: 35.565342, lng: -96.928917, name: 'Oklahoma' },
  OR: { lat: 44.572021, lng: -122.070938, name: 'Oregon' },
  PA: { lat: 40.590752, lng: -77.209755, name: 'Pennsylvania' },
  PR: { lat: 18.220833, lng: -66.590149, name: 'Puerto Rico' },
  RI: { lat: 41.680893, lng: -71.511780, name: 'Rhode Island' },
  SC: { lat: 33.856892, lng: -80.945007, name: 'South Carolina' },
  SD: { lat: 44.299782, lng: -99.438828, name: 'South Dakota' },
  TN: { lat: 35.747845, lng: -86.692345, name: 'Tennessee' },
  TX: { lat: 31.054487, lng: -97.563461, name: 'Texas' },
  UT: { lat: 40.150032, lng: -111.862434, name: 'Utah' },
  VT: { lat: 44.045876, lng: -72.710686, name: 'Vermont' },
  VA: { lat: 37.769337, lng: -78.169968, name: 'Virginia' },
  WA: { lat: 47.400902, lng: -121.490494, name: 'Washington' },
  WV: { lat: 38.491226, lng: -80.954453, name: 'West Virginia' },
  WI: { lat: 44.268543, lng: -89.616508, name: 'Wisconsin' },
  WY: { lat: 42.755966, lng: -107.302490, name: 'Wyoming' },

  // === Canadian Provinces & Territories ===
  ON: { lat: 51.253775, lng: -85.323214, name: 'Ontario', country: 'CA' },
  QC: { lat: 52.939916, lng: -73.549136, name: 'Québec', country: 'CA' },
  BC: { lat: 53.726669, lng: -127.647621, name: 'British Columbia', country: 'CA' },
  AB: { lat: 53.933271, lng: -116.576503, name: 'Alberta', country: 'CA' },
  MB: { lat: 53.760861, lng: -98.813876, name: 'Manitoba', country: 'CA' },
  SK: { lat: 52.939916, lng: -106.450864, name: 'Saskatchewan', country: 'CA' },
  NS: { lat: 44.681987, lng: -63.744311, name: 'Nova Scotia', country: 'CA' },
  NB: { lat: 46.565315, lng: -66.461914, name: 'New Brunswick', country: 'CA' },
  NL: { lat: 53.135509, lng: -57.660435, name: 'Newfoundland and Labrador', country: 'CA' },
  PE: { lat: 46.510712, lng: -63.416813, name: 'Prince Edward Island', country: 'CA' },
  NT: { lat: 64.825520, lng: -124.845703, name: 'Northwest Territories', country: 'CA' },
  YT: { lat: 64.282823, lng: -135.000000, name: 'Yukon', country: 'CA' },
  NU: { lat: 70.298691, lng: -83.107895, name: 'Nunavut', country: 'CA' },

  // === Mexican States ===
  CDMX: { lat: 19.432608, lng: -99.133209, name: 'Ciudad de México', country: 'MX' },
  JAL: { lat: 20.659698, lng: -103.349609, name: 'Jalisco', country: 'MX' },
  NLE: { lat: 25.592172, lng: -99.996063, name: 'Nuevo León', country: 'MX' },
  BCN: { lat: 30.840628, lng: -115.283768, name: 'Baja California', country: 'MX' },
  BCS: { lat: 26.044444, lng: -111.666389, name: 'Baja California Sur', country: 'MX' },
  SON: { lat: 29.072967, lng: -110.955919, name: 'Sonora', country: 'MX' },
  CHH: { lat: 28.632996, lng: -106.069099, name: 'Chihuahua', country: 'MX' },
  COA: { lat: 27.058676, lng: -101.706825, name: 'Coahuila', country: 'MX' },
  TAM: { lat: 24.266667, lng: -98.836111, name: 'Tamaulipas', country: 'MX' },
  SIN: { lat: 25.172339, lng: -107.479528, name: 'Sinaloa', country: 'MX' },
  DUR: { lat: 24.033333, lng: -104.666667, name: 'Durango', country: 'MX' },
  ZAC: { lat: 22.770833, lng: -102.583333, name: 'Zacatecas', country: 'MX' },
  SLP: { lat: 22.156469, lng: -100.985847, name: 'San Luis Potosí', country: 'MX' },
  AGS: { lat: 21.876403, lng: -102.295825, name: 'Aguascalientes', country: 'MX' },
  NAY: { lat: 21.751381, lng: -104.845467, name: 'Nayarit', country: 'MX' },
  COL: { lat: 19.245236, lng: -103.724657, name: 'Colima', country: 'MX' },
  MIC: { lat: 19.566667, lng: -101.706825, name: 'Michoacán', country: 'MX' },
  GUA: { lat: 21.019, lng: -101.257, name: 'Guanajuato', country: 'MX' },
  QUE: { lat: 20.588793, lng: -100.389885, name: 'Querétaro', country: 'MX' },
  HID: { lat: 20.091096, lng: -98.762559, name: 'Hidalgo', country: 'MX' },
  MEX: { lat: 19.494000, lng: -99.686000, name: 'Estado de México', country: 'MX' },
  MOR: { lat: 18.681300, lng: -99.101349, name: 'Morelos', country: 'MX' },
  TLA: { lat: 19.318154, lng: -98.237533, name: 'Tlaxcala', country: 'MX' },
  PUE: { lat: 19.041297, lng: -98.206199, name: 'Puebla', country: 'MX' },
  VER: { lat: 19.173773, lng: -96.134224, name: 'Veracruz', country: 'MX' },
  GRO: { lat: 17.439192, lng: -99.545097, name: 'Guerrero', country: 'MX' },
  OAX: { lat: 17.073182, lng: -96.726608, name: 'Oaxaca', country: 'MX' },
  CHP: { lat: 16.753500, lng: -93.115278, name: 'Chiapas', country: 'MX' },
  TAB: { lat: 17.840816, lng: -92.618830, name: 'Tabasco', country: 'MX' },
  CAM: { lat: 19.830095, lng: -90.534898, name: 'Campeche', country: 'MX' },
  YUC: { lat: 20.709871, lng: -89.094337, name: 'Yucatán', country: 'MX' },
  ROO: { lat: 19.181390, lng: -88.479143, name: 'Quintana Roo', country: 'MX' },

  // === Italian Regions ===
  LOM: { lat: 45.4654, lng: 9.1859, name: 'Lombardy', country: 'IT' },
  LAZ: { lat: 41.9028, lng: 12.4964, name: 'Lazio', country: 'IT' },
  IT_CAM: { lat: 40.8518, lng: 14.2681, name: 'Campania', country: 'IT' },
  SIC: { lat: 37.5999, lng: 14.0154, name: 'Sicily', country: 'IT' },
  VEN: { lat: 45.4408, lng: 12.3155, name: 'Veneto', country: 'IT' },
  EMR: { lat: 44.4949, lng: 11.3426, name: 'Emilia-Romagna', country: 'IT' },
  PIE: { lat: 45.0703, lng: 7.6869, name: 'Piedmont', country: 'IT' },
  TUS: { lat: 43.7711, lng: 11.2486, name: 'Tuscany', country: 'IT' },
  APU: { lat: 41.1257, lng: 16.8667, name: 'Apulia', country: 'IT' },
  IT_CAL: { lat: 38.9060, lng: 16.5942, name: 'Calabria', country: 'IT' },
  SAR: { lat: 40.1209, lng: 9.0129, name: 'Sardinia', country: 'IT' },
  LIG: { lat: 44.4056, lng: 8.9463, name: 'Liguria', country: 'IT' },
  MAR: { lat: 43.6158, lng: 13.5189, name: 'Marche', country: 'IT' },
  ABR: { lat: 42.3514, lng: 13.3920, name: 'Abruzzo', country: 'IT' },
  FVG: { lat: 45.6495, lng: 13.7768, name: 'Friuli-Venezia Giulia', country: 'IT' },
  TAA: { lat: 46.0679, lng: 11.1211, name: 'Trentino-Alto Adige', country: 'IT' },
  UMB: { lat: 42.9385, lng: 12.6217, name: 'Umbria', country: 'IT' },
  IT_BAS: { lat: 40.6394, lng: 15.8052, name: 'Basilicata', country: 'IT' },
  MOL: { lat: 41.5609, lng: 14.6684, name: 'Molise', country: 'IT' },
  VDA: { lat: 45.7389, lng: 7.4262, name: "Valle d'Aosta", country: 'IT' },

  // === German States (Bundesländer) ===
  BY: { lat: 48.7904, lng: 11.4979, name: 'Bavaria', country: 'DE' },
  NW: { lat: 51.4332, lng: 7.6616, name: 'North Rhine-Westphalia', country: 'DE' },
  BW: { lat: 48.6616, lng: 9.3501, name: 'Baden-Württemberg', country: 'DE' },
  NI: { lat: 52.6367, lng: 9.8451, name: 'Lower Saxony', country: 'DE' },
  HE: { lat: 50.6521, lng: 9.1624, name: 'Hesse', country: 'DE' },
  SN: { lat: 51.1045, lng: 13.2017, name: 'Saxony', country: 'DE' },
  BE: { lat: 52.5200, lng: 13.4050, name: 'Berlin', country: 'DE' },
  RP: { lat: 50.1183, lng: 7.3090, name: 'Rhineland-Palatinate', country: 'DE' },
  SH: { lat: 54.2194, lng: 9.6961, name: 'Schleswig-Holstein', country: 'DE' },
  BB: { lat: 52.4125, lng: 12.5316, name: 'Brandenburg', country: 'DE' },
  ST: { lat: 51.9503, lng: 11.6923, name: 'Saxony-Anhalt', country: 'DE' },
  TH: { lat: 50.9010, lng: 11.0344, name: 'Thuringia', country: 'DE' },
  HH: { lat: 53.5511, lng: 9.9937, name: 'Hamburg', country: 'DE' },
  MV: { lat: 53.6127, lng: 12.4296, name: 'Mecklenburg-Vorpommern', country: 'DE' },
  SL: { lat: 49.3964, lng: 7.0230, name: 'Saarland', country: 'DE' },
  HB: { lat: 53.0793, lng: 8.8017, name: 'Bremen', country: 'DE' },

  // === French Regions ===
  IDF: { lat: 48.8566, lng: 2.3522, name: 'Île-de-France', country: 'FR' },
  ARA: { lat: 45.4478, lng: 4.3859, name: 'Auvergne-Rhône-Alpes', country: 'FR' },
  NAQ: { lat: 45.0000, lng: 0.0000, name: 'Nouvelle-Aquitaine', country: 'FR' },
  OCC: { lat: 43.8927, lng: 3.2828, name: 'Occitanie', country: 'FR' },
  HDF: { lat: 49.9667, lng: 2.8167, name: 'Hauts-de-France', country: 'FR' },
  PAC: { lat: 43.9352, lng: 6.0679, name: "Provence-Alpes-Côte d'Azur", country: 'FR' },
  GES: { lat: 48.6996, lng: 6.1872, name: 'Grand Est', country: 'FR' },
  PDL: { lat: 47.4784, lng: -0.5632, name: 'Pays de la Loire', country: 'FR' },
  BRE: { lat: 48.2020, lng: -2.9326, name: 'Brittany', country: 'FR' },
  NOR: { lat: 49.1829, lng: -0.3707, name: 'Normandy', country: 'FR' },
  BFC: { lat: 47.2803, lng: 4.9994, name: 'Bourgogne-Franche-Comté', country: 'FR' },
  CVL: { lat: 47.7516, lng: 1.6751, name: 'Centre-Val de Loire', country: 'FR' },
  COR: { lat: 42.0396, lng: 9.0129, name: 'Corsica', country: 'FR' },

  // Legacy bucket used by older imports for Europe-wide state coding
  EU: { lat: 50.1109, lng: 8.6821, name: 'Europe', country: 'EU' },
  EU_ES: { lat: 40.4168, lng: -3.7038, name: 'Spain', country: 'ES' },
  EU_IT: { lat: 41.9028, lng: 12.4964, name: 'Italy', country: 'IT' },
  EU_NL: { lat: 52.3676, lng: 4.9041, name: 'Netherlands', country: 'NL' },
  EU_CZ: { lat: 50.0755, lng: 14.4378, name: 'Czechia', country: 'CZ' },

  // === Spanish Autonomous Communities ===
  AN: { lat: 37.5443, lng: -4.7278, name: 'Andalusia', country: 'ES' },
  ES_CT: { lat: 41.5912, lng: 1.5209, name: 'Catalonia', country: 'ES' },
  ES_MD: { lat: 40.4168, lng: -3.7038, name: 'Community of Madrid', country: 'ES' },
  VC: { lat: 39.4840, lng: -0.7533, name: 'Valencian Community', country: 'ES' },
  ES_GA: { lat: 42.5751, lng: -8.1339, name: 'Galicia', country: 'ES' },
  CL: { lat: 41.6523, lng: -4.7245, name: 'Castile and León', country: 'ES' },
  PV: { lat: 42.9896, lng: -2.6189, name: 'Basque Country', country: 'ES' },
  CN: { lat: 28.2916, lng: -16.6291, name: 'Canary Islands', country: 'ES' },
  CM: { lat: 39.8628, lng: -4.0273, name: 'Castilla-La Mancha', country: 'ES' },
  MC: { lat: 37.9922, lng: -1.1307, name: 'Region of Murcia', country: 'ES' },
  ES_AR: { lat: 41.5976, lng: -0.9057, name: 'Aragon', country: 'ES' },
  IB: { lat: 39.5696, lng: 2.6502, name: 'Balearic Islands', country: 'ES' },
  EX: { lat: 39.4937, lng: -6.0679, name: 'Extremadura', country: 'ES' },
  AS: { lat: 43.3614, lng: -5.8593, name: 'Asturias', country: 'ES' },
  ES_NC: { lat: 42.6954, lng: -1.6761, name: 'Navarre', country: 'ES' },
  CB: { lat: 43.1828, lng: -3.9878, name: 'Cantabria', country: 'ES' },
  ES_RI: { lat: 42.2871, lng: -2.5396, name: 'La Rioja', country: 'ES' },

  // === United Kingdom Countries ===
  ENG: { lat: 52.3555, lng: -1.1743, name: 'England', country: 'GB' },
  SCT: { lat: 56.4907, lng: -4.2026, name: 'Scotland', country: 'GB' },
  WLS: { lat: 52.1307, lng: -3.7837, name: 'Wales', country: 'GB' },
  NIR: { lat: 54.7877, lng: -6.4923, name: 'Northern Ireland', country: 'GB' },

  // ============== WAVE 2 EUROPEAN COUNTRIES ==============

  // === Netherlands Provinces ===
  NL_NH: { lat: 52.5206, lng: 4.7885, name: 'Noord-Holland', country: 'NL' },
  ZH: { lat: 52.0116, lng: 4.3571, name: 'Zuid-Holland', country: 'NL' },
  NL_NB: { lat: 51.4826, lng: 5.2321, name: 'Noord-Brabant', country: 'NL' },
  GE: { lat: 52.0452, lng: 5.8718, name: 'Gelderland', country: 'NL' },
  NL_UT: { lat: 52.0907, lng: 5.1214, name: 'Utrecht', country: 'NL' },
  OV: { lat: 52.4388, lng: 6.5016, name: 'Overijssel', country: 'NL' },
  LI: { lat: 51.4427, lng: 6.0608, name: 'Limburg', country: 'NL' },
  NL_FR: { lat: 53.1642, lng: 5.7817, name: 'Friesland', country: 'NL' },
  NL_GR: { lat: 53.2194, lng: 6.5665, name: 'Groningen', country: 'NL' },
  DR: { lat: 52.9476, lng: 6.6231, name: 'Drenthe', country: 'NL' },
  NL_FL: { lat: 52.5279, lng: 5.5952, name: 'Flevoland', country: 'NL' },
  ZE: { lat: 51.4940, lng: 3.8497, name: 'Zeeland', country: 'NL' },

  // === Belgium Regions ===
  BRU: { lat: 50.8503, lng: 4.3517, name: 'Brussels', country: 'BE' },
  WAL: { lat: 50.4137, lng: 4.4498, name: 'Wallonia', country: 'BE' },
  VLG: { lat: 51.0500, lng: 3.7303, name: 'Flanders', country: 'BE' },

  // === Austria States ===
  WIE: { lat: 48.2082, lng: 16.3738, name: 'Vienna', country: 'AT' },
  NOE: { lat: 48.1081, lng: 15.8049, name: 'Lower Austria', country: 'AT' },
  OOE: { lat: 48.0250, lng: 13.9709, name: 'Upper Austria', country: 'AT' },
  STM: { lat: 47.3594, lng: 14.4700, name: 'Styria', country: 'AT' },
  TIR: { lat: 47.2537, lng: 11.6015, name: 'Tyrol', country: 'AT' },
  KTN: { lat: 46.7222, lng: 14.1806, name: 'Carinthia', country: 'AT' },
  SBG: { lat: 47.8095, lng: 13.0550, name: 'Salzburg', country: 'AT' },
  VBG: { lat: 47.2500, lng: 9.9000, name: 'Vorarlberg', country: 'AT' },
  BGL: { lat: 47.5000, lng: 16.4167, name: 'Burgenland', country: 'AT' },

  // === Switzerland Cantons ===
  ZHC: { lat: 47.3769, lng: 8.5417, name: 'Zürich', country: 'CH' },
  BER: { lat: 46.9480, lng: 7.4474, name: 'Bern', country: 'CH' },
  VD: { lat: 46.5197, lng: 6.6323, name: 'Vaud', country: 'CH' },
  AG: { lat: 47.3900, lng: 8.0455, name: 'Aargau', country: 'CH' },
  SG: { lat: 47.4245, lng: 9.3767, name: 'St. Gallen', country: 'CH' },
  GEN: { lat: 46.2044, lng: 6.1432, name: 'Geneva', country: 'CH' },
  LU: { lat: 47.0502, lng: 8.3093, name: 'Luzern', country: 'CH' },
  TI: { lat: 46.3316, lng: 8.8005, name: 'Ticino', country: 'CH' },
  VS: { lat: 46.2333, lng: 7.3667, name: 'Valais', country: 'CH' },
  BL: { lat: 47.4417, lng: 7.7633, name: 'Basel-Landschaft', country: 'CH' },
  FRI: { lat: 46.8019, lng: 7.1517, name: 'Fribourg', country: 'CH' },
  TG: { lat: 47.5539, lng: 9.0575, name: 'Thurgau', country: 'CH' },
  SO: { lat: 47.2088, lng: 7.5314, name: 'Solothurn', country: 'CH' },
  BS: { lat: 47.5596, lng: 7.5886, name: 'Basel-Stadt', country: 'CH' },
  GRB: { lat: 46.6563, lng: 9.6283, name: 'Graubünden', country: 'CH' },
  SZ: { lat: 47.0207, lng: 8.6529, name: 'Schwyz', country: 'CH' },
  ZG: { lat: 47.1724, lng: 8.5177, name: 'Zug', country: 'CH' },
  SHA: { lat: 47.6970, lng: 8.6350, name: 'Schaffhausen', country: 'CH' },
  CH_NE: { lat: 46.9900, lng: 6.9293, name: 'Neuchâtel', country: 'CH' },
  JU: { lat: 47.3667, lng: 7.1667, name: 'Jura', country: 'CH' },
  CH_ARC: { lat: 47.3667, lng: 9.2833, name: 'Appenzell Ausserrhoden', country: 'CH' },
  AI: { lat: 47.3167, lng: 9.4167, name: 'Appenzell Innerrhoden', country: 'CH' },
  GL: { lat: 47.0411, lng: 9.0684, name: 'Glarus', country: 'CH' },
  NWC: { lat: 46.9579, lng: 8.3651, name: 'Nidwalden', country: 'CH' },
  OW: { lat: 46.8774, lng: 8.2512, name: 'Obwalden', country: 'CH' },
  URI: { lat: 46.8805, lng: 8.6444, name: 'Uri', country: 'CH' },

  // === Poland Voivodeships ===
  MAZ: { lat: 52.2297, lng: 21.0122, name: 'Masovian', country: 'PL' },
  PL_SLA: { lat: 50.2649, lng: 19.0238, name: 'Silesian', country: 'PL' },
  WLK: { lat: 52.4064, lng: 16.9252, name: 'Greater Poland', country: 'PL' },
  MLP: { lat: 50.0614, lng: 19.9365, name: 'Lesser Poland', country: 'PL' },
  PL_DOL: { lat: 51.1079, lng: 17.0385, name: 'Lower Silesian', country: 'PL' },
  LOD: { lat: 51.7592, lng: 19.4560, name: 'Łódź', country: 'PL' },
  POM: { lat: 54.3520, lng: 18.6466, name: 'Pomeranian', country: 'PL' },
  KUJ: { lat: 53.1235, lng: 18.0084, name: 'Kuyavian-Pomeranian', country: 'PL' },
  LBL: { lat: 51.2465, lng: 22.5684, name: 'Lublin', country: 'PL' },
  PDK: { lat: 50.0413, lng: 21.9991, name: 'Subcarpathian', country: 'PL' },
  ZPM: { lat: 53.4285, lng: 14.5528, name: 'West Pomeranian', country: 'PL' },
  WAM: { lat: 53.7784, lng: 20.4801, name: 'Warmian-Masurian', country: 'PL' },
  SWK: { lat: 50.8661, lng: 20.6286, name: 'Holy Cross', country: 'PL' },
  PL_PDL: { lat: 53.1325, lng: 23.1688, name: 'Podlaskie', country: 'PL' },
  LBS: { lat: 52.0739, lng: 15.2432, name: 'Lubusz', country: 'PL' },
  OPO: { lat: 50.6751, lng: 17.9213, name: 'Opole', country: 'PL' },

  // === Portugal Districts ===
  PT_LIS: { lat: 38.7223, lng: -9.1393, name: 'Lisbon', country: 'PT' },
  PRT: { lat: 41.1579, lng: -8.6291, name: 'Porto', country: 'PT' },
  BRG: { lat: 41.5454, lng: -8.4265, name: 'Braga', country: 'PT' },
  SET: { lat: 38.5244, lng: -8.8882, name: 'Setúbal', country: 'PT' },
  AVE: { lat: 40.6443, lng: -8.6455, name: 'Aveiro', country: 'PT' },
  FAR: { lat: 37.0194, lng: -7.9322, name: 'Faro', country: 'PT' },
  PT_LEI: { lat: 39.7437, lng: -8.8071, name: 'Leiria', country: 'PT' },
  COI: { lat: 40.2033, lng: -8.4103, name: 'Coimbra', country: 'PT' },
  SAN: { lat: 39.2369, lng: -8.6850, name: 'Santarém', country: 'PT' },
  VIS: { lat: 40.6566, lng: -7.9125, name: 'Viseu', country: 'PT' },
  VDC: { lat: 41.6918, lng: -8.8344, name: 'Viana do Castelo', country: 'PT' },
  VLR: { lat: 41.2959, lng: -7.7441, name: 'Vila Real', country: 'PT' },
  CTB: { lat: 39.8222, lng: -7.4917, name: 'Castelo Branco', country: 'PT' },
  PT_GUA: { lat: 40.5373, lng: -7.2677, name: 'Guarda', country: 'PT' },
  EVO: { lat: 38.5714, lng: -7.9135, name: 'Évora', country: 'PT' },
  BEJ: { lat: 38.0146, lng: -7.8640, name: 'Beja', country: 'PT' },
  BGC: { lat: 41.8061, lng: -6.7589, name: 'Bragança', country: 'PT' },
  PT_PTG: { lat: 39.2967, lng: -7.4286, name: 'Portalegre', country: 'PT' },
  AZO: { lat: 37.7412, lng: -25.6756, name: 'Azores', country: 'PT' },
  MAD: { lat: 32.6507, lng: -16.9089, name: 'Madeira', country: 'PT' },

  // === Czech Republic Regions ===
  PHA: { lat: 50.0755, lng: 14.4378, name: 'Prague', country: 'CZ' },
  STC: { lat: 50.0331, lng: 14.8937, name: 'Central Bohemian', country: 'CZ' },
  JHM: { lat: 49.1951, lng: 16.6068, name: 'South Moravian', country: 'CZ' },
  MSK: { lat: 49.8209, lng: 18.2625, name: 'Moravian-Silesian', country: 'CZ' },
  UST: { lat: 50.6119, lng: 13.7750, name: 'Ústí nad Labem', country: 'CZ' },
  JHC: { lat: 49.0475, lng: 14.4780, name: 'South Bohemian', country: 'CZ' },
  PLZ: { lat: 49.7384, lng: 13.3736, name: 'Plzeň', country: 'CZ' },
  OLM: { lat: 49.5955, lng: 17.2518, name: 'Olomouc', country: 'CZ' },
  KHK: { lat: 50.2092, lng: 15.8328, name: 'Hradec Králové', country: 'CZ' },
  ZLN: { lat: 49.2265, lng: 17.6673, name: 'Zlín', country: 'CZ' },
  PAR: { lat: 50.0343, lng: 15.7812, name: 'Pardubice', country: 'CZ' },
  LBR: { lat: 50.7663, lng: 15.0543, name: 'Liberec', country: 'CZ' },
  VYS: { lat: 49.3961, lng: 15.5912, name: 'Vysočina', country: 'CZ' },
  KVY: { lat: 50.2327, lng: 12.8714, name: 'Karlovy Vary', country: 'CZ' },

  // === Sweden Counties ===
  STK: { lat: 59.3293, lng: 18.0686, name: 'Stockholm', country: 'SE' },
  VGL: { lat: 58.2528, lng: 12.5718, name: 'Västra Götaland', country: 'SE' },
  SKA: { lat: 55.9903, lng: 13.5958, name: 'Skåne', country: 'SE' },
  OST: { lat: 58.4108, lng: 15.6214, name: 'Östergötland', country: 'SE' },
  UPP: { lat: 59.8586, lng: 17.6389, name: 'Uppsala', country: 'SE' },
  JON: { lat: 57.7815, lng: 14.1562, name: 'Jönköping', country: 'SE' },
  HAL: { lat: 56.6745, lng: 12.8578, name: 'Halland', country: 'SE' },
  SE_ORE: { lat: 59.2753, lng: 15.2134, name: 'Örebro', country: 'SE' },
  GAV: { lat: 60.6749, lng: 17.1413, name: 'Gävleborg', country: 'SE' },
  SOD: { lat: 59.0336, lng: 16.7519, name: 'Södermanland', country: 'SE' },
  DAL: { lat: 61.0917, lng: 14.6664, name: 'Dalarna', country: 'SE' },
  VAS: { lat: 59.6162, lng: 16.5528, name: 'Västmanland', country: 'SE' },
  VBT: { lat: 64.7499, lng: 18.2855, name: 'Västerbotten', country: 'SE' },
  NRB: { lat: 66.8309, lng: 20.3992, name: 'Norrbotten', country: 'SE' },
  VRM: { lat: 59.7294, lng: 13.2354, name: 'Värmland', country: 'SE' },
  KAL: { lat: 57.2356, lng: 16.1878, name: 'Kalmar', country: 'SE' },
  KRO: { lat: 56.8777, lng: 14.8091, name: 'Kronoberg', country: 'SE' },
  BLE: { lat: 56.1612, lng: 15.5869, name: 'Blekinge', country: 'SE' },
  VNR: { lat: 63.1792, lng: 17.3045, name: 'Västernorrland', country: 'SE' },
  JAM: { lat: 63.1712, lng: 14.6361, name: 'Jämtland', country: 'SE' },
  GOT: { lat: 57.4684, lng: 18.4867, name: 'Gotland', country: 'SE' },

  // === Norway Counties ===
  VIK: { lat: 59.7439, lng: 10.2045, name: 'Viken', country: 'NO' },
  OSL: { lat: 59.9139, lng: 10.7522, name: 'Oslo', country: 'NO' },
  ROG: { lat: 59.1330, lng: 5.9667, name: 'Rogaland', country: 'NO' },
  VES: { lat: 60.3913, lng: 5.3221, name: 'Vestland', country: 'NO' },
  NO_TRO: { lat: 63.4305, lng: 10.3951, name: 'Trøndelag', country: 'NO' },
  INN: { lat: 61.1500, lng: 10.5000, name: 'Innlandet', country: 'NO' },
  VFT: { lat: 59.2671, lng: 9.4067, name: 'Vestfold og Telemark', country: 'NO' },
  AGD: { lat: 58.4631, lng: 7.9979, name: 'Agder', country: 'NO' },
  NO_MOR: { lat: 62.4722, lng: 6.1495, name: 'Møre og Romsdal', country: 'NO' },
  NO_NOR: { lat: 67.2800, lng: 14.4049, name: 'Nordland', country: 'NO' },
  TRF: { lat: 69.6496, lng: 18.9560, name: 'Troms og Finnmark', country: 'NO' },

  // === Denmark Regions ===
  HOV: { lat: 55.6761, lng: 12.5683, name: 'Capital Region', country: 'DK' },
  MID: { lat: 56.4372, lng: 9.4028, name: 'Central Denmark', country: 'DK' },
  SYD: { lat: 55.3959, lng: 9.4695, name: 'Southern Denmark', country: 'DK' },
  NJY: { lat: 56.9636, lng: 9.8142, name: 'North Denmark', country: 'DK' },
  DK_SJA: { lat: 55.4116, lng: 11.7695, name: 'Zealand', country: 'DK' },

  // === Finland Regions ===
  UUS: { lat: 60.1699, lng: 24.9384, name: 'Uusimaa', country: 'FI' },
  PIR: { lat: 61.4978, lng: 23.7610, name: 'Pirkanmaa', country: 'FI' },
  VAR: { lat: 60.4518, lng: 22.2666, name: 'Southwest Finland', country: 'FI' },
  PPO: { lat: 65.0121, lng: 25.4651, name: 'North Ostrobothnia', country: 'FI' },
  KES: { lat: 62.2426, lng: 25.7473, name: 'Central Finland', country: 'FI' },
  SAT: { lat: 61.4846, lng: 21.7979, name: 'Satakunta', country: 'FI' },
  PSA: { lat: 62.8924, lng: 27.6783, name: 'North Savo', country: 'FI' },
  PAH: { lat: 60.9827, lng: 25.6612, name: 'Päijät-Häme', country: 'FI' },
  POH: { lat: 63.0951, lng: 21.6165, name: 'Ostrobothnia', country: 'FI' },
  LAP: { lat: 66.5039, lng: 25.7294, name: 'Lapland', country: 'FI' },
  EPO: { lat: 62.7900, lng: 22.8403, name: 'South Ostrobothnia', country: 'FI' },
  KYM: { lat: 60.8679, lng: 26.7043, name: 'Kymenlaakso', country: 'FI' },
  KAH: { lat: 60.9958, lng: 24.4649, name: 'Kanta-Häme', country: 'FI' },
  ESA: { lat: 61.6875, lng: 27.2736, name: 'South Savo', country: 'FI' },
  PKA: { lat: 62.6001, lng: 29.7636, name: 'North Karelia', country: 'FI' },
  EKA: { lat: 61.0587, lng: 28.1887, name: 'South Karelia', country: 'FI' },
  KAI: { lat: 64.2279, lng: 27.7286, name: 'Kainuu', country: 'FI' },
  KPO: { lat: 63.8368, lng: 23.1310, name: 'Central Ostrobothnia', country: 'FI' },
  AHV: { lat: 60.1000, lng: 19.9333, name: 'Åland', country: 'FI' },

  // === Ireland Provinces ===
  IE_LEI: { lat: 53.3498, lng: -6.2603, name: 'Leinster', country: 'IE' },
  MUN: { lat: 52.1545, lng: -8.5669, name: 'Munster', country: 'IE' },
  IE_CON: { lat: 53.8008, lng: -8.9989, name: 'Connacht', country: 'IE' },
  ULS: { lat: 54.5973, lng: -7.3092, name: 'Ulster', country: 'IE' },

  // === Greece Regions ===
  ATT: { lat: 37.9838, lng: 23.7275, name: 'Attica', country: 'GR' },
  KMK: { lat: 40.6401, lng: 22.9444, name: 'Central Macedonia', country: 'GR' },
  THE: { lat: 39.6392, lng: 22.4191, name: 'Thessaly', country: 'GR' },
  DEL: { lat: 38.2904, lng: 21.7878, name: 'Western Greece', country: 'GR' },
  KRI: { lat: 35.2401, lng: 24.8093, name: 'Crete', country: 'GR' },
  STE: { lat: 38.8963, lng: 22.4349, name: 'Central Greece', country: 'GR' },
  PEL: { lat: 37.5079, lng: 22.3738, name: 'Peloponnese', country: 'GR' },
  AMT: { lat: 41.1171, lng: 24.8879, name: 'East Macedonia & Thrace', country: 'GR' },
  EPI: { lat: 39.6650, lng: 20.8537, name: 'Epirus', country: 'GR' },
  DMK: { lat: 40.3007, lng: 21.7891, name: 'Western Macedonia', country: 'GR' },
  NAI: { lat: 37.0858, lng: 25.1497, name: 'South Aegean', country: 'GR' },
  BAI: { lat: 39.0986, lng: 26.5551, name: 'North Aegean', country: 'GR' },
  ION: { lat: 39.6243, lng: 19.9217, name: 'Ionian Islands', country: 'GR' },

  // === Hungary Counties ===
  BUD: { lat: 47.4979, lng: 19.0402, name: 'Budapest', country: 'HU' },
  PES: { lat: 47.2667, lng: 19.5667, name: 'Pest', country: 'HU' },
  BAZ: { lat: 48.1025, lng: 20.7860, name: 'Borsod-Abaúj-Zemplén', country: 'HU' },
  HAB: { lat: 47.5316, lng: 21.6273, name: 'Hajdú-Bihar', country: 'HU' },
  SSB: { lat: 48.1000, lng: 22.0833, name: 'Szabolcs-Szatmár-Bereg', country: 'HU' },
  BAK: { lat: 46.5962, lng: 19.3593, name: 'Bács-Kiskun', country: 'HU' },
  GMS: { lat: 47.6849, lng: 17.6345, name: 'Győr-Moson-Sopron', country: 'HU' },
  CSC: { lat: 46.2530, lng: 20.1414, name: 'Csongrád-Csanád', country: 'HU' },
  FEJ: { lat: 47.1896, lng: 18.4104, name: 'Fejér', country: 'HU' },
  JNS: { lat: 47.1628, lng: 20.1995, name: 'Jász-Nagykun-Szolnok', country: 'HU' },
  BAR: { lat: 46.0727, lng: 18.2323, name: 'Baranya', country: 'HU' },
  SOM: { lat: 46.3574, lng: 17.5875, name: 'Somogy', country: 'HU' },
  VESH: { lat: 47.0936, lng: 17.9100, name: 'Veszprém', country: 'HU' },
  VASH: { lat: 47.2300, lng: 16.6218, name: 'Vas', country: 'HU' },
  BEK: { lat: 46.6736, lng: 21.0877, name: 'Békés', country: 'HU' },
  HEV: { lat: 47.9026, lng: 20.3727, name: 'Heves', country: 'HU' },
  ZAL: { lat: 46.8417, lng: 16.8416, name: 'Zala', country: 'HU' },
  TOL: { lat: 46.4167, lng: 18.5500, name: 'Tolna', country: 'HU' },
  NOG: { lat: 48.0667, lng: 19.5000, name: 'Nógrád', country: 'HU' },
  KOE: { lat: 47.7500, lng: 18.5000, name: 'Komárom-Esztergom', country: 'HU' },

  // === Croatia Counties ===
  HR_ZAG: { lat: 45.8150, lng: 15.9819, name: 'Zagreb City', country: 'HR' },
  SPL: { lat: 43.5081, lng: 16.4402, name: 'Split-Dalmatia', country: 'HR' },
  ZGZ: { lat: 45.7900, lng: 16.0833, name: 'Zagreb County', country: 'HR' },
  PGZ: { lat: 45.3267, lng: 14.4417, name: 'Primorje-Gorski Kotar', country: 'HR' },
  OBZ: { lat: 45.5511, lng: 18.6939, name: 'Osijek-Baranja', country: 'HR' },
  IST: { lat: 45.2150, lng: 13.9300, name: 'Istria', country: 'HR' },
  VSZ: { lat: 45.3500, lng: 18.8000, name: 'Vukovar-Srijem', country: 'HR' },
  ZAD: { lat: 44.1194, lng: 15.2314, name: 'Zadar', country: 'HR' },
  SMZ: { lat: 45.4667, lng: 16.3833, name: 'Sisak-Moslavina', country: 'HR' },
  VARH: { lat: 46.3044, lng: 16.3378, name: 'Varaždin', country: 'HR' },
  DNZ: { lat: 42.6507, lng: 18.0944, name: 'Dubrovnik-Neretva', country: 'HR' },
  BPZ: { lat: 45.1628, lng: 18.0153, name: 'Brod-Posavina', country: 'HR' },
  KAR: { lat: 45.4929, lng: 15.5553, name: 'Karlovac', country: 'HR' },
  KKZ: { lat: 46.1658, lng: 16.8303, name: 'Koprivnica-Križevci', country: 'HR' },
  BBZ: { lat: 45.8989, lng: 16.8422, name: 'Bjelovar-Bilogora', country: 'HR' },
  KZZ: { lat: 46.1575, lng: 15.8733, name: 'Krapina-Zagorje', country: 'HR' },
  SKZ: { lat: 43.7372, lng: 15.8914, name: 'Šibenik-Knin', country: 'HR' },
  MEZ: { lat: 46.3833, lng: 16.4333, name: 'Međimurje', country: 'HR' },
  PSZ: { lat: 45.3375, lng: 17.6803, name: 'Požega-Slavonia', country: 'HR' },
  VPZ: { lat: 45.8311, lng: 17.3839, name: 'Virovitica-Podravina', country: 'HR' },
  LSZ: { lat: 44.5392, lng: 15.0506, name: 'Lika-Senj', country: 'HR' },

  // === Romania Counties ===
  BUC: { lat: 44.4268, lng: 26.1025, name: 'Bucharest', country: 'RO' },
  CLJ: { lat: 46.7712, lng: 23.6236, name: 'Cluj', country: 'RO' },
  TIM: { lat: 45.7489, lng: 21.2087, name: 'Timiș', country: 'RO' },
  IAS: { lat: 47.1585, lng: 27.6014, name: 'Iași', country: 'RO' },
  CST: { lat: 44.1598, lng: 28.6348, name: 'Constanța', country: 'RO' },
  RO_BRS: { lat: 45.6427, lng: 25.5887, name: 'Brașov', country: 'RO' },
  PRH: { lat: 44.9437, lng: 26.0237, name: 'Prahova', country: 'RO' },
  RO_DOL: { lat: 44.3301, lng: 23.7949, name: 'Dolj', country: 'RO' },
  ARG: { lat: 44.8565, lng: 24.8692, name: 'Argeș', country: 'RO' },
  BAC: { lat: 46.5670, lng: 26.9146, name: 'Bacău', country: 'RO' },
  BIH: { lat: 47.0458, lng: 21.9189, name: 'Bihor', country: 'RO' },
  SUC: { lat: 47.6514, lng: 25.9008, name: 'Suceava', country: 'RO' },
  GAL: { lat: 45.4353, lng: 28.0080, name: 'Galați', country: 'RO' },
  MUR: { lat: 46.5422, lng: 24.5579, name: 'Mureș', country: 'RO' },
  SIB: { lat: 45.7983, lng: 24.1256, name: 'Sibiu', country: 'RO' },
  HUN: { lat: 45.7491, lng: 22.9019, name: 'Hunedoara', country: 'RO' },
  ARAR: { lat: 46.1866, lng: 21.3123, name: 'Arad', country: 'RO' },
  MARR: { lat: 47.6667, lng: 24.0000, name: 'Maramureș', country: 'RO' },
  NEA: { lat: 46.9759, lng: 26.3817, name: 'Neamț', country: 'RO' },
  RO_ALB: { lat: 46.0694, lng: 23.5675, name: 'Alba', country: 'RO' },
  BUZ: { lat: 45.1500, lng: 26.8167, name: 'Buzău', country: 'RO' },
  BOT: { lat: 47.7500, lng: 26.6667, name: 'Botoșani', country: 'RO' },
  VLC: { lat: 45.0994, lng: 24.3695, name: 'Vâlcea', country: 'RO' },
  DAM: { lat: 44.9268, lng: 25.4599, name: 'Dâmbovița', country: 'RO' },
  OLT: { lat: 44.4268, lng: 24.3614, name: 'Olt', country: 'RO' },
  SATR: { lat: 47.7900, lng: 22.8858, name: 'Satu Mare', country: 'RO' },
  TEL: { lat: 43.9783, lng: 25.3333, name: 'Teleorman', country: 'RO' },
  GOR: { lat: 44.9019, lng: 23.2744, name: 'Gorj', country: 'RO' },
  VASR: { lat: 46.6407, lng: 27.7276, name: 'Vaslui', country: 'RO' },
  VRA: { lat: 45.6964, lng: 27.1875, name: 'Vrancea', country: 'RO' },
  BRA: { lat: 45.2692, lng: 27.9575, name: 'Brăila', country: 'RO' },
  RO_CRS: { lat: 45.0667, lng: 22.0500, name: 'Caraș-Severin', country: 'RO' },
  MEH: { lat: 44.6333, lng: 22.6500, name: 'Mehedinți', country: 'RO' },
  TUL: { lat: 45.1786, lng: 28.8003, name: 'Tulcea', country: 'RO' },
  RO_CAL: { lat: 44.2000, lng: 27.0000, name: 'Călărași', country: 'RO' },
  GIU: { lat: 43.9037, lng: 25.9699, name: 'Giurgiu', country: 'RO' },
  IAL: { lat: 44.5667, lng: 27.3833, name: 'Ialomița', country: 'RO' },
  SAL: { lat: 47.1833, lng: 23.0500, name: 'Sălaj', country: 'RO' },
  BIS: { lat: 47.1333, lng: 24.5000, name: 'Bistrița-Năsăud', country: 'RO' },
  HAR: { lat: 46.3597, lng: 25.8042, name: 'Harghita', country: 'RO' },
  RO_COV: { lat: 45.8667, lng: 26.1833, name: 'Covasna', country: 'RO' },
  ILF: { lat: 44.5667, lng: 26.0833, name: 'Ilfov', country: 'RO' },

  // ============== LATIN AMERICA ==============

  // === Brazil States ===
  SP: { lat: -23.5505, lng: -46.6333, name: 'São Paulo', country: 'BR' },
  MGS: { lat: -19.9167, lng: -43.9345, name: 'Minas Gerais', country: 'BR' },
  RJ: { lat: -22.9068, lng: -43.1729, name: 'Rio de Janeiro', country: 'BR' },
  BR_BAS: { lat: -12.9714, lng: -38.5014, name: 'Bahia', country: 'BR' },
  RSS: { lat: -30.0346, lng: -51.2177, name: 'Rio Grande do Sul', country: 'BR' },
  BR_PRS: { lat: -25.4284, lng: -49.2733, name: 'Paraná', country: 'BR' },
  PEB: { lat: -8.0476, lng: -34.8770, name: 'Pernambuco', country: 'BR' },
  CEB: { lat: -3.7172, lng: -38.5433, name: 'Ceará', country: 'BR' },
  PAB: { lat: -1.4558, lng: -48.4902, name: 'Pará', country: 'BR' },
  BR_SCB: { lat: -27.5954, lng: -48.5480, name: 'Santa Catarina', country: 'BR' },
  MAB: { lat: -2.5387, lng: -44.2826, name: 'Maranhão', country: 'BR' },
  GOB: { lat: -16.6869, lng: -49.2648, name: 'Goiás', country: 'BR' },
  AMB: { lat: -3.1190, lng: -60.0217, name: 'Amazonas', country: 'BR' },
  ESB: { lat: -20.3155, lng: -40.3128, name: 'Espírito Santo', country: 'BR' },
  PBB: { lat: -7.1195, lng: -34.8450, name: 'Paraíba', country: 'BR' },
  RNB: { lat: -5.7945, lng: -35.2110, name: 'Rio Grande do Norte', country: 'BR' },
  MTB: { lat: -15.6014, lng: -56.0979, name: 'Mato Grosso', country: 'BR' },
  BR_ALB: { lat: -9.6658, lng: -35.7350, name: 'Alagoas', country: 'BR' },
  PIB: { lat: -5.0920, lng: -42.8038, name: 'Piauí', country: 'BR' },
  DFB: { lat: -15.7942, lng: -47.8822, name: 'Distrito Federal', country: 'BR' },
  MSB: { lat: -20.4697, lng: -54.6201, name: 'Mato Grosso do Sul', country: 'BR' },
  SEB: { lat: -10.9472, lng: -37.0731, name: 'Sergipe', country: 'BR' },
  ROB: { lat: -8.7612, lng: -63.9004, name: 'Rondônia', country: 'BR' },
  BR_TOB: { lat: -10.1689, lng: -48.3317, name: 'Tocantins', country: 'BR' },
  ACB: { lat: -9.0238, lng: -70.8120, name: 'Acre', country: 'BR' },
  APB: { lat: 0.0356, lng: -51.0694, name: 'Amapá', country: 'BR' },
  RRB: { lat: 2.8235, lng: -60.6758, name: 'Roraima', country: 'BR' },

  // === Argentina Provinces ===
  BAA: { lat: -34.6037, lng: -58.3816, name: 'Buenos Aires', country: 'AR' },
  CAB: { lat: -34.6037, lng: -58.3816, name: 'Ciudad de Buenos Aires', country: 'AR' },
  CDA: { lat: -31.4201, lng: -64.1888, name: 'Córdoba', country: 'AR' },
  SFA: { lat: -31.6333, lng: -60.7000, name: 'Santa Fe', country: 'AR' },
  MZA: { lat: -32.8895, lng: -68.8458, name: 'Mendoza', country: 'AR' },
  TUA: { lat: -26.8083, lng: -65.2176, name: 'Tucumán', country: 'AR' },
  ERA: { lat: -31.7333, lng: -60.5333, name: 'Entre Ríos', country: 'AR' },
  SAA: { lat: -24.7821, lng: -65.4232, name: 'Salta', country: 'AR' },
  MNA: { lat: -27.3671, lng: -55.8961, name: 'Misiones', country: 'AR' },
  CHA: { lat: -27.4512, lng: -58.9867, name: 'Chaco', country: 'AR' },
  CWA: { lat: -27.4692, lng: -58.8306, name: 'Corrientes', country: 'AR' },
  SEA: { lat: -27.7833, lng: -64.2667, name: 'Santiago del Estero', country: 'AR' },
  AR_SJA: { lat: -31.5375, lng: -68.5364, name: 'San Juan', country: 'AR' },
  JYA: { lat: -24.1858, lng: -65.2995, name: 'Jujuy', country: 'AR' },
  RNA: { lat: -40.8135, lng: -63.0000, name: 'Río Negro', country: 'AR' },
  NQA: { lat: -38.9516, lng: -68.0591, name: 'Neuquén', country: 'AR' },
  FOA: { lat: -26.1775, lng: -58.1781, name: 'Formosa', country: 'AR' },
  CHU: { lat: -43.3002, lng: -65.1023, name: 'Chubut', country: 'AR' },
  AR_SLA: { lat: -33.2955, lng: -66.3356, name: 'San Luis', country: 'AR' },
  CTA: { lat: -28.4696, lng: -65.7795, name: 'Catamarca', country: 'AR' },
  LRA: { lat: -29.4131, lng: -66.8558, name: 'La Rioja', country: 'AR' },
  LPA: { lat: -36.6147, lng: -64.2839, name: 'La Pampa', country: 'AR' },
  SZA: { lat: -51.6226, lng: -69.2181, name: 'Santa Cruz', country: 'AR' },
  TFA: { lat: -54.8019, lng: -68.3030, name: 'Tierra del Fuego', country: 'AR' },

  // === Colombia Departments ===
  DCC: { lat: 4.7110, lng: -74.0721, name: 'Bogotá D.C.', country: 'CO' },
  ANTC: { lat: 6.2442, lng: -75.5812, name: 'Antioquia', country: 'CO' },
  VACC: { lat: 3.4516, lng: -76.5320, name: 'Valle del Cauca', country: 'CO' },
  CUNC: { lat: 4.6097, lng: -74.0817, name: 'Cundinamarca', country: 'CO' },
  ATLC: { lat: 10.9685, lng: -74.7813, name: 'Atlántico', country: 'CO' },
  SANC: { lat: 7.1254, lng: -73.1198, name: 'Santander', country: 'CO' },
  BOLC: { lat: 10.3910, lng: -75.4794, name: 'Bolívar', country: 'CO' },
  NARC: { lat: 1.2136, lng: -77.2811, name: 'Nariño', country: 'CO' },
  CORC: { lat: 8.7479, lng: -75.8814, name: 'Córdoba', country: 'CO' },
  TOLC: { lat: 4.4389, lng: -75.2322, name: 'Tolima', country: 'CO' },
  CAUC: { lat: 2.4419, lng: -76.6067, name: 'Cauca', country: 'CO' },
  NSAC: { lat: 7.8891, lng: -72.4967, name: 'Norte de Santander', country: 'CO' },
  BOYC: { lat: 5.5353, lng: -73.3678, name: 'Boyacá', country: 'CO' },
  MAGC: { lat: 11.2408, lng: -74.1990, name: 'Magdalena', country: 'CO' },
  HUIC: { lat: 2.9273, lng: -75.2819, name: 'Huila', country: 'CO' },
  CESC: { lat: 10.4631, lng: -73.2532, name: 'Cesar', country: 'CO' },
  RISC: { lat: 4.8087, lng: -75.6906, name: 'Risaralda', country: 'CO' },
  METC: { lat: 4.1420, lng: -73.6266, name: 'Meta', country: 'CO' },
  CALC: { lat: 5.0689, lng: -75.5174, name: 'Caldas', country: 'CO' },
  LAGC: { lat: 11.5444, lng: -72.9072, name: 'La Guajira', country: 'CO' },
  SUCC: { lat: 9.3047, lng: -75.3978, name: 'Sucre', country: 'CO' },
  QUIC: { lat: 4.5339, lng: -75.6811, name: 'Quindío', country: 'CO' },
  CHOC: { lat: 5.6919, lng: -76.6583, name: 'Chocó', country: 'CO' },
  CAQC: { lat: 1.6144, lng: -75.6062, name: 'Caquetá', country: 'CO' },
  CASC: { lat: 5.3378, lng: -72.3959, name: 'Casanare', country: 'CO' },
  PUTC: { lat: 1.1528, lng: -76.6519, name: 'Putumayo', country: 'CO' },
  ARAC: { lat: 7.0847, lng: -70.7592, name: 'Arauca', country: 'CO' },
  AMAC: { lat: -1.0000, lng: -71.9333, name: 'Amazonas', country: 'CO' },
  GUVC: { lat: 2.5667, lng: -72.6417, name: 'Guaviare', country: 'CO' },
  VIDC: { lat: 4.4419, lng: -69.2836, name: 'Vichada', country: 'CO' },
  GUAC: { lat: 3.8653, lng: -67.9239, name: 'Guainía', country: 'CO' },
  VAUC: { lat: 1.1953, lng: -70.1778, name: 'Vaupés', country: 'CO' },
  SAPC: { lat: 12.5847, lng: -81.7006, name: 'San Andrés', country: 'CO' },

  // === Chile Regions ===
  RMC: { lat: -33.4489, lng: -70.6693, name: 'Santiago Metropolitan', country: 'CL' },
  VSC: { lat: -33.0472, lng: -71.6127, name: 'Valparaíso', country: 'CL' },
  BIC: { lat: -36.8261, lng: -73.0498, name: 'Biobío', country: 'CL' },
  MLC: { lat: -35.4264, lng: -71.6554, name: 'Maule', country: 'CL' },
  CL_LIC: { lat: -34.1708, lng: -70.7444, name: "O'Higgins", country: 'CL' },
  CL_ARC: { lat: -38.7396, lng: -72.5984, name: 'Araucanía', country: 'CL' },
  LGC: { lat: -41.4718, lng: -72.9369, name: 'Los Lagos', country: 'CL' },
  COC: { lat: -29.9533, lng: -71.3395, name: 'Coquimbo', country: 'CL' },
  ANC: { lat: -23.6509, lng: -70.3975, name: 'Antofagasta', country: 'CL' },
  LRC: { lat: -39.8485, lng: -73.2436, name: 'Los Ríos', country: 'CL' },
  TAC: { lat: -20.2140, lng: -70.1522, name: 'Tarapacá', country: 'CL' },
  ATC: { lat: -27.3668, lng: -70.3323, name: 'Atacama', country: 'CL' },
  NBC: { lat: -36.6096, lng: -72.1034, name: 'Ñuble', country: 'CL' },
  APC: { lat: -18.4783, lng: -70.3126, name: 'Arica y Parinacota', country: 'CL' },
  AIC: { lat: -45.5752, lng: -72.0662, name: 'Aysén', country: 'CL' },
  MAC: { lat: -53.1548, lng: -70.9113, name: 'Magallanes', country: 'CL' },

  // === Peru Departments ===
  LIMP: { lat: -12.0464, lng: -77.0428, name: 'Lima', country: 'PE' },
  LALP: { lat: -8.1116, lng: -79.0288, name: 'La Libertad', country: 'PE' },
  PIUP: { lat: -5.1945, lng: -80.6328, name: 'Piura', country: 'PE' },
  CAJP: { lat: -7.1638, lng: -78.5003, name: 'Cajamarca', country: 'PE' },
  PUNP: { lat: -15.8402, lng: -70.0219, name: 'Puno', country: 'PE' },
  JUNP: { lat: -12.0651, lng: -75.2049, name: 'Junín', country: 'PE' },
  CUSP: { lat: -13.5319, lng: -71.9675, name: 'Cusco', country: 'PE' },
  AREP: { lat: -16.4090, lng: -71.5375, name: 'Arequipa', country: 'PE' },
  LAMP: { lat: -6.7714, lng: -79.8409, name: 'Lambayeque', country: 'PE' },
  ANCP: { lat: -9.5299, lng: -77.5282, name: 'Áncash', country: 'PE' },
  LORP: { lat: -3.7491, lng: -73.2538, name: 'Loreto', country: 'PE' },
  HUCP: { lat: -9.9306, lng: -76.2422, name: 'Huánuco', country: 'PE' },
  SAMP: { lat: -6.4855, lng: -76.3606, name: 'San Martín', country: 'PE' },
  ICAP: { lat: -14.0678, lng: -75.7286, name: 'Ica', country: 'PE' },
  AYAP: { lat: -13.1588, lng: -74.2236, name: 'Ayacucho', country: 'PE' },
  HUVP: { lat: -12.7869, lng: -74.9730, name: 'Huancavelica', country: 'PE' },
  UCAP: { lat: -8.3791, lng: -74.5539, name: 'Ucayali', country: 'PE' },
  APUP: { lat: -13.6339, lng: -72.8814, name: 'Apurímac', country: 'PE' },
  AMAP: { lat: -6.2315, lng: -77.8628, name: 'Amazonas', country: 'PE' },
  TACP: { lat: -18.0146, lng: -70.2536, name: 'Tacna', country: 'PE' },
  PASP: { lat: -10.6830, lng: -76.2563, name: 'Pasco', country: 'PE' },
  TUMP: { lat: -3.5669, lng: -80.4515, name: 'Tumbes', country: 'PE' },
  MOQP: { lat: -17.1939, lng: -70.9356, name: 'Moquegua', country: 'PE' },
  MDDP: { lat: -12.5933, lng: -69.1891, name: 'Madre de Dios', country: 'PE' },
  CALP: { lat: -12.0565, lng: -77.1181, name: 'Callao', country: 'PE' },

  // === Venezuela States ===
  DFV: { lat: 10.4806, lng: -66.9036, name: 'Distrito Capital', country: 'VE' },
  ZUV: { lat: 10.6666, lng: -71.6125, name: 'Zulia', country: 'VE' },
  MIV: { lat: 10.4696, lng: -66.8032, name: 'Miranda', country: 'VE' },
  CAV: { lat: 10.1579, lng: -67.9972, name: 'Carabobo', country: 'VE' },
  LAV: { lat: 10.0678, lng: -69.3467, name: 'Lara', country: 'VE' },
  ARV: { lat: 10.2337, lng: -67.5910, name: 'Aragua', country: 'VE' },
  BOV: { lat: 8.1136, lng: -63.5517, name: 'Bolívar', country: 'VE' },
  ANV: { lat: 10.1253, lng: -64.6820, name: 'Anzoátegui', country: 'VE' },
  TAV: { lat: 7.7667, lng: -72.2000, name: 'Táchira', country: 'VE' },
  MEV: { lat: 8.5897, lng: -71.1561, name: 'Mérida', country: 'VE' },
  FAV: { lat: 11.4236, lng: -69.6575, name: 'Falcón', country: 'VE' },
  BAV: { lat: 8.6272, lng: -70.2070, name: 'Barinas', country: 'VE' },
  MOV: { lat: 9.7489, lng: -63.1767, name: 'Monagas', country: 'VE' },
  TRV: { lat: 9.3647, lng: -70.4342, name: 'Trujillo', country: 'VE' },
  POV: { lat: 9.0589, lng: -69.7461, name: 'Portuguesa', country: 'VE' },
  GUV: { lat: 8.7489, lng: -66.9370, name: 'Guárico', country: 'VE' },
  SUV: { lat: 10.4505, lng: -63.2556, name: 'Sucre', country: 'VE' },
  YAV: { lat: 10.3500, lng: -68.7500, name: 'Yaracuy', country: 'VE' },
  NEV: { lat: 11.0000, lng: -63.9167, name: 'Nueva Esparta', country: 'VE' },
  VE_COV: { lat: 9.6667, lng: -68.5833, name: 'Cojedes', country: 'VE' },
  APV: { lat: 7.8833, lng: -67.4667, name: 'Apure', country: 'VE' },
  DAV: { lat: 9.0667, lng: -62.0500, name: 'Delta Amacuro', country: 'VE' },
  VAV: { lat: 10.6000, lng: -66.9333, name: 'Vargas', country: 'VE' },
  AMV: { lat: 5.6667, lng: -67.6167, name: 'Amazonas', country: 'VE' },

  // === Ecuador Provinces ===
  GYE: { lat: -2.1710, lng: -79.9224, name: 'Guayas', country: 'EC' },
  PCE: { lat: -0.1807, lng: -78.4678, name: 'Pichincha', country: 'EC' },
  MNE: { lat: -1.0547, lng: -80.4545, name: 'Manabí', country: 'EC' },
  LRE: { lat: -1.8045, lng: -79.5342, name: 'Los Ríos', country: 'EC' },
  AZE: { lat: -2.9001, lng: -79.0059, name: 'Azuay', country: 'EC' },
  EOE: { lat: -3.2581, lng: -79.9601, name: 'El Oro', country: 'EC' },
  ESE: { lat: 0.9592, lng: -79.6539, name: 'Esmeraldas', country: 'EC' },
  TUE: { lat: -1.2491, lng: -78.6168, name: 'Tungurahua', country: 'EC' },
  CBE: { lat: -1.6636, lng: -78.6546, name: 'Chimborazo', country: 'EC' },
  IME: { lat: 0.3517, lng: -78.1223, name: 'Imbabura', country: 'EC' },
  CTE: { lat: -0.9342, lng: -78.6144, name: 'Cotopaxi', country: 'EC' },
  LJE: { lat: -3.9931, lng: -79.2042, name: 'Loja', country: 'EC' },
  SDE: { lat: -0.2522, lng: -79.1723, name: 'Santo Domingo', country: 'EC' },
  SEE: { lat: -2.2267, lng: -80.8589, name: 'Santa Elena', country: 'EC' },
  BOE: { lat: -1.5911, lng: -79.0004, name: 'Bolívar', country: 'EC' },
  CRE: { lat: 0.8177, lng: -77.7185, name: 'Carchi', country: 'EC' },
  CNE: { lat: -2.5564, lng: -78.9386, name: 'Cañar', country: 'EC' },
  SUE: { lat: 0.0833, lng: -76.8833, name: 'Sucumbíos', country: 'EC' },
  EC_ORE: { lat: -0.4653, lng: -76.9900, name: 'Orellana', country: 'EC' },
  NAE: { lat: -0.9500, lng: -77.8167, name: 'Napo', country: 'EC' },
  PAE: { lat: -1.4833, lng: -78.0000, name: 'Pastaza', country: 'EC' },
  MSE: { lat: -2.3050, lng: -78.1147, name: 'Morona-Santiago', country: 'EC' },
  ZCE: { lat: -4.0689, lng: -78.9539, name: 'Zamora-Chinchipe', country: 'EC' },
  GAE: { lat: -0.7455, lng: -90.3135, name: 'Galápagos', country: 'EC' },

  // === Guatemala Departments ===
  GUG: { lat: 14.6349, lng: -90.5069, name: 'Guatemala', country: 'GT' },
  AVG: { lat: 15.4833, lng: -90.3833, name: 'Alta Verapaz', country: 'GT' },
  HUG: { lat: 15.3190, lng: -91.4707, name: 'Huehuetenango', country: 'GT' },
  QCG: { lat: 15.0333, lng: -91.1500, name: 'Quiché', country: 'GT' },
  SMG: { lat: 14.9667, lng: -91.8000, name: 'San Marcos', country: 'GT' },
  QZG: { lat: 14.8333, lng: -91.5167, name: 'Quetzaltenango', country: 'GT' },
  GT_ESG: { lat: 14.3047, lng: -90.7875, name: 'Escuintla', country: 'GT' },
  PEG: { lat: 16.9167, lng: -89.8833, name: 'Petén', country: 'GT' },
  CMG: { lat: 14.6333, lng: -90.8167, name: 'Chimaltenango', country: 'GT' },
  SUG: { lat: 14.5333, lng: -91.5000, name: 'Suchitepéquez', country: 'GT' },
  JUG: { lat: 14.2833, lng: -89.8833, name: 'Jutiapa', country: 'GT' },
  TOG: { lat: 14.9167, lng: -91.3667, name: 'Totonicapán', country: 'GT' },
  IZG: { lat: 15.4833, lng: -88.8667, name: 'Izabal', country: 'GT' },
  SOG: { lat: 14.7667, lng: -91.1833, name: 'Sololá', country: 'GT' },
  SRG: { lat: 14.2833, lng: -90.2833, name: 'Santa Rosa', country: 'GT' },
  REG: { lat: 14.5333, lng: -91.6833, name: 'Retalhuleu', country: 'GT' },
  JAG: { lat: 14.6333, lng: -89.9833, name: 'Jalapa', country: 'GT' },
  CQG: { lat: 14.8000, lng: -89.5500, name: 'Chiquimula', country: 'GT' },
  BVG: { lat: 15.1167, lng: -90.3667, name: 'Baja Verapaz', country: 'GT' },
  GT_ZAG: { lat: 14.9667, lng: -89.5333, name: 'Zacapa', country: 'GT' },
  SAG: { lat: 14.5500, lng: -90.7333, name: 'Sacatepéquez', country: 'GT' },
  PRG: { lat: 14.8500, lng: -90.0667, name: 'El Progreso', country: 'GT' },

  // === Honduras Departments ===
  FMH: { lat: 14.0818, lng: -87.2068, name: 'Francisco Morazán', country: 'HN' },
  CRH: { lat: 15.5049, lng: -88.0250, name: 'Cortés', country: 'HN' },
  YOH: { lat: 15.1333, lng: -87.4500, name: 'Yoro', country: 'HN' },
  OLH: { lat: 14.7667, lng: -86.1500, name: 'Olancho', country: 'HN' },
  CMH: { lat: 14.4500, lng: -87.6333, name: 'Comayagua', country: 'HN' },
  HN_CHH: { lat: 13.3000, lng: -87.1833, name: 'Choluteca', country: 'HN' },
  ATH: { lat: 15.7500, lng: -87.4667, name: 'Atlántida', country: 'HN' },
  CPH: { lat: 14.9167, lng: -88.9667, name: 'Copán', country: 'HN' },
  SBH: { lat: 14.9167, lng: -88.2333, name: 'Santa Bárbara', country: 'HN' },
  LEH: { lat: 14.6167, lng: -88.5833, name: 'Lempira', country: 'HN' },
  EPH: { lat: 13.9667, lng: -86.5667, name: 'El Paraíso', country: 'HN' },
  LPH: { lat: 14.3167, lng: -87.6833, name: 'La Paz', country: 'HN' },
  INH: { lat: 14.3667, lng: -88.1667, name: 'Intibucá', country: 'HN' },
  CLH: { lat: 15.7667, lng: -85.9667, name: 'Colón', country: 'HN' },
  VAH: { lat: 13.5833, lng: -87.5667, name: 'Valle', country: 'HN' },
  OCH: { lat: 14.4333, lng: -89.1833, name: 'Ocotepeque', country: 'HN' },
  GDH: { lat: 15.2500, lng: -84.5000, name: 'Gracias a Dios', country: 'HN' },
  IBH: { lat: 16.3333, lng: -86.5333, name: 'Islas de la Bahía', country: 'HN' },

  // === El Salvador Departments ===
  SSS: { lat: 13.6929, lng: -89.2182, name: 'San Salvador', country: 'SV' },
  SV_LIS: { lat: 13.4833, lng: -89.3167, name: 'La Libertad', country: 'SV' },
  SV_SAS: { lat: 13.9833, lng: -89.5500, name: 'Santa Ana', country: 'SV' },
  SMS: { lat: 13.4833, lng: -88.1833, name: 'San Miguel', country: 'SV' },
  SOS: { lat: 13.7167, lng: -89.7167, name: 'Sonsonate', country: 'SV' },
  USS: { lat: 13.3500, lng: -88.4500, name: 'Usulután', country: 'SV' },
  AHS: { lat: 13.9167, lng: -89.8500, name: 'Ahuachapán', country: 'SV' },
  UNS: { lat: 13.3333, lng: -87.8500, name: 'La Unión', country: 'SV' },
  PAS: { lat: 13.5000, lng: -88.9500, name: 'La Paz', country: 'SV' },
  CHS: { lat: 14.0333, lng: -88.9333, name: 'Chalatenango', country: 'SV' },
  CUS: { lat: 13.8500, lng: -88.9333, name: 'Cuscatlán', country: 'SV' },
  SVS: { lat: 13.6333, lng: -88.8000, name: 'San Vicente', country: 'SV' },
  CAS: { lat: 13.8667, lng: -88.6333, name: 'Cabañas', country: 'SV' },
  MOS: { lat: 13.7500, lng: -88.1000, name: 'Morazán', country: 'SV' },

  // === Nicaragua Departments ===
  MNN: { lat: 12.1364, lng: -86.2514, name: 'Managua', country: 'NI' },
  MTN: { lat: 12.9167, lng: -85.9167, name: 'Matagalpa', country: 'NI' },
  LEN: { lat: 12.4333, lng: -86.8833, name: 'León', country: 'NI' },
  CIN: { lat: 12.6167, lng: -87.0333, name: 'Chinandega', country: 'NI' },
  MSN: { lat: 11.9667, lng: -86.0833, name: 'Masaya', country: 'NI' },
  GRN: { lat: 11.9333, lng: -85.9500, name: 'Granada', country: 'NI' },
  ESN: { lat: 13.0833, lng: -86.3500, name: 'Estelí', country: 'NI' },
  JIN: { lat: 13.0833, lng: -85.9833, name: 'Jinotega', country: 'NI' },
  NI_CON: { lat: 12.0833, lng: -85.3667, name: 'Chontales', country: 'NI' },
  RIN: { lat: 11.4333, lng: -85.8333, name: 'Rivas', country: 'NI' },
  CAN: { lat: 11.8500, lng: -86.2000, name: 'Carazo', country: 'NI' },
  NSN: { lat: 13.6333, lng: -86.4667, name: 'Nueva Segovia', country: 'NI' },
  BON: { lat: 12.4667, lng: -85.6500, name: 'Boaco', country: 'NI' },
  MDN: { lat: 13.4833, lng: -86.4500, name: 'Madriz', country: 'NI' },
  SJN: { lat: 11.0500, lng: -84.7667, name: 'Río San Juan', country: 'NI' },
  ANN: { lat: 14.0333, lng: -83.3833, name: 'RACN', country: 'NI' },
  ASN: { lat: 12.1833, lng: -84.0000, name: 'RACS', country: 'NI' },

  // === Costa Rica Provinces ===
  SJC: { lat: 9.9281, lng: -84.0907, name: 'San José', country: 'CR' },
  ALC: { lat: 10.0167, lng: -84.2167, name: 'Alajuela', country: 'CR' },
  CAC: { lat: 9.8667, lng: -83.9167, name: 'Cartago', country: 'CR' },
  HEC: { lat: 10.0000, lng: -84.1167, name: 'Heredia', country: 'CR' },
  GUC: { lat: 10.4667, lng: -85.4333, name: 'Guanacaste', country: 'CR' },
  PUC: { lat: 9.9667, lng: -84.8333, name: 'Puntarenas', country: 'CR' },
  CR_LIC: { lat: 9.9833, lng: -83.0333, name: 'Limón', country: 'CR' },

  // === Panama Provinces ===
  PMP: { lat: 9.0833, lng: -79.3833, name: 'Panamá', country: 'PA' },
  POP: { lat: 9.0333, lng: -79.5500, name: 'Panamá Oeste', country: 'PA' },
  PA_CHP: { lat: 8.4333, lng: -82.4333, name: 'Chiriquí', country: 'PA' },
  CLP: { lat: 9.3667, lng: -79.8833, name: 'Colón', country: 'PA' },
  CCP: { lat: 8.5000, lng: -80.3833, name: 'Coclé', country: 'PA' },
  VEP: { lat: 8.0833, lng: -81.0833, name: 'Veraguas', country: 'PA' },
  HEP: { lat: 7.8167, lng: -80.7833, name: 'Herrera', country: 'PA' },
  LSP: { lat: 7.5000, lng: -80.3833, name: 'Los Santos', country: 'PA' },
  BTP: { lat: 9.3333, lng: -82.2500, name: 'Bocas del Toro', country: 'PA' },
  DAP: { lat: 8.0833, lng: -77.7500, name: 'Darién', country: 'PA' },
  EMP: { lat: 8.5000, lng: -77.8333, name: 'Emberá', country: 'PA' },
  KYP: { lat: 9.3500, lng: -78.2000, name: 'Guna Yala', country: 'PA' },
  NBP: { lat: 8.8833, lng: -81.6667, name: 'Ngäbe-Buglé', country: 'PA' },

  // === Belize Districts ===
  BZB: { lat: 17.4978, lng: -88.1866, name: 'Belize', country: 'BZ' },
  CYB: { lat: 17.2500, lng: -88.7667, name: 'Cayo', country: 'BZ' },
  OWB: { lat: 18.0833, lng: -88.5667, name: 'Orange Walk', country: 'BZ' },
  CZB: { lat: 18.4000, lng: -88.3833, name: 'Corozal', country: 'BZ' },
  BZ_SCB: { lat: 16.9667, lng: -88.4000, name: 'Stann Creek', country: 'BZ' },
  BZ_TOB: { lat: 16.2167, lng: -88.7500, name: 'Toledo', country: 'BZ' },

  // === Bolivia Departments ===
  SCO: { lat: -17.7833, lng: -63.1821, name: 'Santa Cruz', country: 'BO' },
  LPO: { lat: -16.5000, lng: -68.1500, name: 'La Paz', country: 'BO' },
  CBO: { lat: -17.3833, lng: -66.1500, name: 'Cochabamba', country: 'BO' },
  POO: { lat: -19.5833, lng: -65.7500, name: 'Potosí', country: 'BO' },
  CQO: { lat: -19.0333, lng: -65.2500, name: 'Chuquisaca', country: 'BO' },
  ORO: { lat: -17.9647, lng: -67.1114, name: 'Oruro', country: 'BO' },
  BO_TRO: { lat: -21.5167, lng: -64.7333, name: 'Tarija', country: 'BO' },
  EBO: { lat: -14.8333, lng: -64.9000, name: 'El Beni', country: 'BO' },
  PAO: { lat: -11.0167, lng: -68.7667, name: 'Pando', country: 'BO' },

  // === Paraguay Departments ===
  ASP: { lat: -25.2637, lng: -57.5759, name: 'Asunción', country: 'PY' },
  CEP: { lat: -25.5000, lng: -57.5000, name: 'Central', country: 'PY' },
  AAP: { lat: -25.5167, lng: -54.6167, name: 'Alto Paraná', country: 'PY' },
  ITP: { lat: -27.0000, lng: -55.8833, name: 'Itapúa', country: 'PY' },
  CGP: { lat: -25.5000, lng: -55.7500, name: 'Caaguazú', country: 'PY' },
  SPP: { lat: -24.1000, lng: -56.5833, name: 'San Pedro', country: 'PY' },
  CRP: { lat: -25.2500, lng: -57.0000, name: 'Cordillera', country: 'PY' },
  PGP: { lat: -25.8333, lng: -57.0000, name: 'Paraguarí', country: 'PY' },
  GUP: { lat: -25.7500, lng: -56.4333, name: 'Guairá', country: 'PY' },
  CNP: { lat: -23.4167, lng: -57.4333, name: 'Concepción', country: 'PY' },
  CYP: { lat: -24.0833, lng: -55.2500, name: 'Canindeyú', country: 'PY' },
  CZP: { lat: -26.1667, lng: -56.0000, name: 'Caazapá', country: 'PY' },
  AMP: { lat: -22.5500, lng: -55.7500, name: 'Amambay', country: 'PY' },
  MIP: { lat: -26.8333, lng: -57.0000, name: 'Misiones', country: 'PY' },
  NEP: { lat: -26.8833, lng: -58.1000, name: 'Ñeembucú', country: 'PY' },
  PHP: { lat: -23.1000, lng: -59.5000, name: 'Presidente Hayes', country: 'PY' },
  AGP: { lat: -21.5000, lng: -59.5000, name: 'Alto Paraguay', country: 'PY' },
  BQP: { lat: -21.4167, lng: -60.7500, name: 'Boquerón', country: 'PY' },

  // === Uruguay Departments ===
  MOU: { lat: -34.9011, lng: -56.1645, name: 'Montevideo', country: 'UY' },
  CAU: { lat: -34.5333, lng: -56.2833, name: 'Canelones', country: 'UY' },
  MAU: { lat: -34.9167, lng: -54.9500, name: 'Maldonado', country: 'UY' },
  SAU: { lat: -31.3833, lng: -57.9667, name: 'Salto', country: 'UY' },
  COU: { lat: -34.4667, lng: -57.8500, name: 'Colonia', country: 'UY' },
  PAU: { lat: -32.3167, lng: -58.0833, name: 'Paysandú', country: 'UY' },
  SJU: { lat: -34.3333, lng: -56.7167, name: 'San José', country: 'UY' },
  RVU: { lat: -30.9000, lng: -55.5500, name: 'Rivera', country: 'UY' },
  SOU: { lat: -33.2500, lng: -57.5167, name: 'Soriano', country: 'UY' },
  TAU: { lat: -31.7167, lng: -55.9833, name: 'Tacuarembó', country: 'UY' },
  CLU: { lat: -32.3667, lng: -54.1833, name: 'Cerro Largo', country: 'UY' },
  ROU: { lat: -34.4833, lng: -54.2167, name: 'Rocha', country: 'UY' },
  ARU: { lat: -30.4000, lng: -56.4667, name: 'Artigas', country: 'UY' },
  FDU: { lat: -34.0833, lng: -56.2167, name: 'Florida', country: 'UY' },
  LAU: { lat: -34.3333, lng: -55.2500, name: 'Lavalleja', country: 'UY' },
  DUU: { lat: -33.3667, lng: -56.5167, name: 'Durazno', country: 'UY' },
  RNU: { lat: -32.3500, lng: -57.4333, name: 'Río Negro', country: 'UY' },
  TTU: { lat: -33.2333, lng: -54.3667, name: 'Treinta y Tres', country: 'UY' },
  FSU: { lat: -33.5167, lng: -56.8833, name: 'Flores', country: 'UY' },

  // === Guyana Regions ===
  DEG: { lat: 6.8045, lng: -58.1553, name: 'Demerara-Mahaica', country: 'GY' },
  EBG: { lat: 6.2500, lng: -57.5000, name: 'East Berbice-Corentyne', country: 'GY' },
  GY_ESG: { lat: 6.8000, lng: -58.4000, name: 'Essequibo Islands-West Demerara', country: 'GY' },
  MAG: { lat: 6.3333, lng: -57.9167, name: 'Mahaica-Berbice', country: 'GY' },
  PMG: { lat: 7.5000, lng: -58.7500, name: 'Pomeroon-Supenaam', country: 'GY' },
  UDG: { lat: 5.7500, lng: -58.2500, name: 'Upper Demerara-Berbice', country: 'GY' },
  CUG: { lat: 6.0000, lng: -60.0000, name: 'Cuyuni-Mazaruni', country: 'GY' },
  GY_PTG: { lat: 5.0000, lng: -59.5000, name: 'Potaro-Siparuni', country: 'GY' },
  UTG: { lat: 2.5000, lng: -59.0000, name: 'Upper Takutu-Upper Essequibo', country: 'GY' },
  BAG: { lat: 7.5000, lng: -59.5000, name: 'Barima-Waini', country: 'GY' },

  // === Suriname Districts ===
  PMS: { lat: 5.8520, lng: -55.2038, name: 'Paramaribo', country: 'SR' },
  WAS: { lat: 5.7667, lng: -55.2500, name: 'Wanica', country: 'SR' },
  NIS: { lat: 5.9333, lng: -56.9833, name: 'Nickerie', country: 'SR' },
  SR_PRS: { lat: 5.5000, lng: -55.5000, name: 'Para', country: 'SR' },
  CMS: { lat: 5.9000, lng: -54.8500, name: 'Commewijne', country: 'SR' },
  MAS: { lat: 5.5500, lng: -54.0500, name: 'Marowijne', country: 'SR' },
  SR_SAS: { lat: 5.7833, lng: -55.8000, name: 'Saramacca', country: 'SR' },
  SR_BRS: { lat: 5.0667, lng: -55.0667, name: 'Brokopondo', country: 'SR' },
  SR_CRS: { lat: 5.9500, lng: -56.2833, name: 'Coronie', country: 'SR' },
  SIS: { lat: 4.0000, lng: -56.0000, name: 'Sipaliwini', country: 'SR' },
}

// Michigan is always loaded in detail, other states show aggregates until zoomed
export const HOME_STATE = 'MI'

// Zoom level at which to show individual markers for non-home states
export const STATE_DETAIL_ZOOM = 7

// Get centroid for a state
export function getStateCentroid(stateCode) {
  return STATE_CENTROIDS[stateCode] || null
}

// Check if a state code is valid
export function isValidState(stateCode) {
  return stateCode && STATE_CENTROIDS.hasOwnProperty(stateCode)
}
